// extracted by mini-css-extract-plugin
export var banner = "_rr-0";
export var settingRow = "_rr-2";
export var titleIcon = "_rr-1";